// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentIssueNotice_container__AlZQV","actions":"paymentIssueNotice_actions__uISJC","note":"paymentIssueNotice_note__X7O6z"};